module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-1314.fffa9d66.jpg";